import { render, staticRenderFns } from "./SubmitMaterials.vue?vue&type=template&id=50d6c820&scoped=true"
import script from "./SubmitMaterials.vue?vue&type=script&lang=js"
export * from "./SubmitMaterials.vue?vue&type=script&lang=js"
import style0 from "./SubmitMaterials.vue?vue&type=style&index=0&id=50d6c820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d6c820",
  null
  
)

export default component.exports